<template>
  <v-app>
    <v-navigation-drawer
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      app>
     
      <v-list>
        <div v-for="item in menuItems()" :key="item.title">
          <v-divider v-if="item.isDivider == true"></v-divider>
          <v-list-tile v-else :to="item.link">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            
            <v-list-tile-content>
                  {{ item.title }}
            </v-list-tile-content>
          </v-list-tile>      
        </div>     
        <div v-for="item in helpItems()" :key="item.title">
          <v-list-tile @click="openDocument();">
            <v-list-tile-action>
              <v-icon flat>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>{{ item.title }}</v-list-tile-content>
          </v-list-tile>
        </div>  
        <div v-for="item in externalItems()" :key="item.title">
          <v-list-tile @click="openExternalLink(item.link)">
            <v-list-tile-action>
              <v-icon flat>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>{{ item.title }}</v-list-tile-content>
          </v-list-tile>
        </div>  
        <v-divider></v-divider>
        <social></social> 
      </v-list>
    </v-navigation-drawer>

    <v-toolbar fixed app :clipped-left="clipped" color="primary" dark>
      <v-toolbar-side-icon @click.native="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <period-selector class="flex xs4" v-on:period-selected="onPeriodSelected()" ref="periodselector" />
      <account-controls></account-controls>
      <help-controls></help-controls>
    </v-toolbar>

    <v-content>
      <v-alert v-model="showInactive" icon="warning" outline>
        The selected period is not active or it has been completed. All the data is in read only mode.
      </v-alert>
      <v-alert v-model="showInvisibles" icon="warning" outline>
        There are no visible periods.
      </v-alert>
      <v-container fluid class="pa-0">        
        <v-slide-y-transition mode="out-in">      
          <router-view 
          :key="contentview"
            ref="contentview"
            v-on:actives-changed="activesChanged()" 
            v-on:period-added="periodAdded()" 
            v-on:selected-deleted="selectedDeleted()" 
            v-on:show-period-notification="reShowNotification()"
            v-on:refresh-content-view="refreshContentView()">
          </router-view>    
        </v-slide-y-transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

  import PeriodSelector from '../PeriodSelector'
  import AccountControls from '../AccountControls'
  import HelpControls from '../HelpControls'
  import Social from '../Social'
  import { globalStore } from '../../main.js'
  import { getMenuItems } from '../../utils/menubuilder'
  import { store } from '../../store'
  import { getPeriods, initialize, getCompletedPeriods, getSetting, getHelpFile, getReportingPeriodStatus } from '../../utils/effort-tracking-api'
  import { TeacherEfforts } from '../TeacherEfforts'
  import { getExternalLinks } from '../../utils/menubuilder'
  import { getHelpLinks } from '../../utils/menubuilder'

  export default {
    name: 'Navigation',
    components: {
      PeriodSelector,
      AccountControls,
      HelpControls,
      Social
    },
    data () {
      return {
        clipped: true,
        drawer: true,
        fixed: true,
        miniVariant: false,
        right: false,
        title: 'Effort Tracking',
        showInactive: false,
        showInvisibles: false,
        periods: [],
        isTeacher: false,
        isStudent: false,
        completedPeriods: 0,
        contentview: 0
      }
    },
    watch: {
        $route: {
            handler (to, from) {
              this.showInactive = false;
            },
        },
    },
    methods: {
      refreshContentView () {
        // Alter the contentview key to force the content update
        this.contentview++;
      },
      onPeriodSelected (periodId) {
        // Alter the contentview key to force the content update
        this.contentview++;
      },
      reShowNotification() {
        initialize().then(x => {
          // console.log('Getting reporting period status:');
          getReportingPeriodStatus().then(result => {  
            console.log('Reporting period status: ');
            console.log(result);
            this.showInactive =  !result.active || result.complete;
            // console.log('this.showInactive: ');
            // console.log(this.showInactive);
          }).catch(ex => console.log(ex));
        }).catch(ex => console.log(ex));

        // console.log('On reshow notification');
        if (this === undefined) {
          return false;
        }
        var periods = this.$store.state.periods;
        if(periods.length == 0)
        {
          return false;
        }
        
        // // if(globalStore === undefined)
        // //   globalStore.selectedPeriod = periods.filter(p => p.active)[0].value;
        

        // // var periodId = localStorage.getItem('period-selected');
        // // var period = periods.filter(pp => pp.id == Number(periodId));
        // // var route = this.$route;
        // // console.log('Route: ');
        // // console.log(route);

        // if(period.length > 0 && (route.name == 'TeacherEfforts' || route.name == 'StudentEfforts'))
        // {

        // }
      },
      menuItems() {
        // get User state
        var usertype = this.$store.state.usertype;
        if (this.$store.state.userdata != null)
        {
          var userId = this.$store.state.userdata.id;
          var periods = this.$store.state.periods;
          var periodId = localStorage.getItem('period-selected');
          var period = periods.filter(pp => pp.id == periodId);
          var periodComplete = period.length > 0 ? period[0].complete : false;
        }
        
        if (usertype == 'student' && this.completedPeriods > 0)
        {
          return getMenuItems(usertype, userId, periodComplete, true);   
        } else {
          return getMenuItems(usertype, userId, periodComplete, false);
        }
      },

      externalItems() {
        var links = getExternalLinks();
        return getExternalLinks();
      },

      helpItems() {
        var links = getHelpLinks();
        return getHelpLinks();
      },

      activesChanged() {
        
        this.showInactive = false;
        getPeriods().then( periods => {
          this.$store.state.periods = [];
          var activePeriods = [];

          periods.forEach(period => {
            var p = {
              text: period.text,
              id: Number(period.value),
              startDate: new Date(period.startDate),
              endDate: new Date(period.endDate),
              active: period.active,
              complete: period.complete
            };

            this.$store.state.periods.push(p);
            if(p.active)
                activePeriods.push(period.value);
          });

          if ((this.$route.name == 'TeacherEfforts' || this.$route.name == 'StudentEfforts') && this.$store.state.usertype != "admin" && periods.filter(p => p.visible).length == 0)
          {
            this.showInactive = false;
            this.showInvisibles = true;
          }

          this.$refs.periodselector.update();
        });
      },

      periodAdded( ) {
        this.$refs.periodselector.update();
      },

      selectedDeleted() {
          var periods = store.state.periods;
          var lsPeriod = localStorage.getItem('period-selected');
          var indexes = periods.map(ii => ii.id);
          if(indexes.indexOf(lsPeriod) == -1) {
              this.$refs.periodselector.update();
              localStorage.setItem('period-selected', -1);
          }
      },

      openExternalLink(link) {
        console.log(link);
        window.open(link, '_blank');
      },

      openDocument() {
            var document = getHelpFile(this.$store.state.usertype);
        }
    },

    created() {
      initialize().then(x => {
        getSetting('widget-id').then(widgetId => {
          localStorage.setItem('widget-id', '');
            if(widgetId != '')
              localStorage.setItem('widget-id', widgetId.value);
        }).catch(ex => console.log(ex));

        getCompletedPeriods(this.$store.state.userdata.id).then(result => {  
          this.completedPeriods = result.length;
        }).catch(ex => console.log(ex));
      }).catch(ex => console.log(ex));
    },
    mounted() {
      var defaultPeriod = localStorage.getItem('period-selected');
      if(defaultPeriod != 0)
      {
        this.$refs.periodselector.selectDefaultPeriod(defaultPeriod);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/layouts/Navigation.vue